import React, { useState, useEffect } from "react";
import axios from "axios";
import { Divider, message } from "antd";
import { ModalItem, ButtonItem, InputItem } from "../../../../../Components/Items";
import { WA } from "../../theme";
import { payloadVacio, asignarIds, limpiarPayload } from "../Helpers/interactivosHelpers";
import ConstructorInteractivo, { validarConstruido } from "../ConstructorInteractivo";

// Crea/edita un elemento interactivo 
const EditorElemento = ({ visible, headersToken, empresaId, elemento, onCancel, onGuardado }) => {
  const [tipo, setTipo] = useState("buttons");
  const [nombre, setNombre] = useState("");
  const [payload, setPayload] = useState(payloadVacio("buttons"));
  const [guardando, setGuardando] = useState(false);

  const esEdicion = !!elemento;

  useEffect(() => {
    if (!visible) return;
    if (elemento) {
      setTipo(elemento.tipo);
      setNombre(elemento.nombre);
      setPayload({ ...payloadVacio(elemento.tipo), ...elemento.payload });
    } else {
      setTipo("buttons");
      setNombre("");
      setPayload(payloadVacio("buttons"));
    }
  }, [visible, elemento]);

  const guardar = () => {
    if (!nombre.trim()) return message.error("Ponle un nombre al elemento.");
    const err = validarConstruido(tipo, payload);
    if (err) return message.error(err);

    const limpio = limpiarPayload(asignarIds(tipo, payload));
    const endpoint = esEdicion ? "whatsapp/elementoEditar" : "whatsapp/elementoCrear";
    const body = esEdicion
      ? { elementoId: elemento._id, nombre: nombre.trim(), payload: limpio }
      : { empresaId, tipo, nombre: nombre.trim(), payload: limpio };

    setGuardando(true);
    axios
      .post(endpoint, body, { headers: headersToken })
      .then((r) => {
        if (r.data.success === 2) {
          message.success(esEdicion ? "Elemento actualizado." : "Elemento creado.");
          onGuardado();
        } else {
          message.error(r.data.message || "No se pudo guardar.");
        }
      })
      .catch(() => message.error("Error de red al guardar."))
      .finally(() => setGuardando(false));
  };

  const tituloSeccion = { fontWeight: 600, margin: "12px 0 4px", color: WA.textPrimary };

  return (
    <ModalItem
      title={esEdicion ? "Editar elemento" : "Nuevo elemento"}
      visible={visible}
      onCancel={onCancel}
      width={560}
      zIndex={1200}
      destroyOnClose
      spinning={guardando}
    >
      <div style={tituloSeccion}>Nombre (interno)</div>
      <InputItem
        placeholder="Ej. Confirmación de cita"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        maxLength={60}
      />

      <Divider style={{ margin: "16px 0 8px" }} />

      <ConstructorInteractivo
        tipo={tipo}
        setTipo={setTipo}
        payload={payload}
        setPayload={setPayload}
        bloquearTipo={esEdicion}
      />

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
        <ButtonItem rojo onClick={onCancel}>Cancelar</ButtonItem>
        <ButtonItem lima onClick={guardar} loading={guardando}>Guardar</ButtonItem>
      </div>
    </ModalItem>
  );
};

export default EditorElemento;
